import React from "react";
import "./GurgaonContent.css";
import { Link } from "react-router-dom";
import ReactGA from  "react-ga4";
import { useNavigate } from "react-router-dom";

function GurgaonContent() {

  const navigate = useNavigate();
  const handleNavigation = (eventName, word, route) =>{
    ReactGA.gtag("event", eventName, {    
      word: word, 
    });
    window.location.href = route
  }
  const goToHomePage = () => handleNavigation("city_word_clicked" , "DriveU" , "https://www.driveu.in/");
  const driversForWeekend  = () => handleNavigation("city_word_clicked" , "weekend_getaways" , "/drivers-for-weekend/");
  const nightTime = () => handleNavigation("city_word_clicked" , "night_time" , "/drivers-for-night");
  return (
    <div className="Hyderabad_Content_main_div">
      <div className="Hyderabad_Content_main_div_Heading">
        DriveU in Gurgaon
      </div>
      <div className="Hyderabad_Content_main_div_content">
        he convenience and the luxury of having your own personal driver just a
        few taps away, DriveU brings you’re their professional chauffeur service
        which lets you hire drivers in Delhi on an hourly basis. Choose from
        DriveU’s fleet of trusted, verified and trained drivers at rates
        starting from just Rs.129/hour.{" "}
        <span onClick={goToHomePage} style={{ color: "green" }}>
          DriveU
        </span>{" "}
        is the perfect solution to a range of your traveling issues. Whether it
        is the daily commute to your work or a{" "}
        <span onClick={driversForWeekend} style={{ color: "green" }}>
          weekend getaways
        </span>{" "}
        , DriveU allows you to sit back and relax, while our drivers make you
        reach your destination safely. Our{" "}
        <span onClick={nightTime}  style={{ color: "green" }}>
          night time drivers
        </span>{" "}
        for late nights, letting you enjoy with the peace of mind of reaching
        back home safely. DriveU realizes the importance of this by providing a
        quick, reliable and easy way to hire drivers in Gurgaon.
      </div>
    </div>
  );
}

export default GurgaonContent;
